module.exports = __webpack_public_path__ + "media/images/help/faq-dashboard-status-sp-33bef803f4006dc4a2e49f07a259920d.jpg";